<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 class="text-xs-center">
        <img style="width:100%;" src="@/assets/logo_flow_simulation_game_by_AGILEA.png" class="pb-3"/>
        <v-card class="elevation-12">
          <v-form ref="loginForm" @submit.prevent="login">
            <v-toolbar dark color="primary">
              <v-spacer></v-spacer>
              <v-toolbar-title>Flow Simulation Game</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                @blur="toLowerCaser"
                v-model.trim="credential.account"
                prepend-icon="business_center"
                name="account"
                label="Account"
                type="text"
                :rules="[v => !!v || 'Requis']"
              ></v-text-field>
              <v-text-field
                v-model.trim="credential.login"
                prepend-icon="person"
                name="login"
                label="Login"
                type="text"
                :rules="[v => !!v || 'Requis']"
              ></v-text-field>
              <v-text-field
                v-model="credential.pwd"
                id="password"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
                :rules="[v => !!v || 'Requis']"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" type="submit" :loading="$store.state.user.loading">Login</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {

  name: "Login",

  data() {
    return {
      credential: {
        login: "",
        pwd: "",
        account: ""
      }
    };
  },

  mounted() {
    this.checkIfAlreadyAuth()
    this.credential.account = this.account
  },

  methods: {

    toLowerCaser() {
      this.credential.account = this.credential.account.toLowerCase()
    },

    login() {
      this.credential.account = this.credential.account.toLowerCase()
      if (this.$refs.loginForm.validate()) {
        this.userLogin(this.credential);
      }
    },

    ...mapActions('user', {
      userLogin: 'login',
      checkIfAlreadyAuth: 'checkIfAlreadyAuth'
    })

  },

  computed: {

    ...mapGetters('interfaceSettings', {
      account: 'account'
    })

  }
};
</script>
